export class Parallax {

    static init() {
        Parallax.stageParallax();

        window.addEventListener("scroll", () => {
            Parallax.stageParallax();
        });
    }

    static offset(el) {
        const rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
    }

    static parallax(parent, children) {
        const parentOffset = this.offset(parent);
        if (!window.matchMedia('(min-width: 1280px) and (min-height: 900px)').matches) {
            const scroll = (window.pageYOffset - parentOffset.top)/5;
            children.style.transform = 'translateY(' + -scroll + 'px)';
        }
    }

    static stageParallax() {
        const parallaxEls = document.querySelectorAll('.stage-box-parallax');

        if (parallaxEls.length > 0){
            parallaxEls.forEach( el => {
                const parent = el.closest('.stage-box');
                Parallax.parallax(parent, el);
            });
        }
    }
}